import { arrayPitchCore } from './ChecklistEvaluationArrayPitch';
import { ChecklistEvaluationKey } from './ChecklistEvaluations';
import type { EvaluationCoreDescriptor } from './ChecklistEvaluations';
import { serialValidationCore } from './ChecklistEvaluationSerialValidation';
import { solarEdgeOptimizerCore } from './ChecklistEvaluationSolarEdgeOptimizer';
import { systemLossCore } from './ChecklistEvaluationSystemLoss';
import { firstYearProductionCore, systemSizeCore } from './ChecklistEvaluationSystemSize';

export const checklistEvaluationCoreRegistry: Record<ChecklistEvaluationKey, EvaluationCoreDescriptor> = {
  [ChecklistEvaluationKey.systemSize]: systemSizeCore,
  [ChecklistEvaluationKey.firstYearProduction]: firstYearProductionCore,
  [ChecklistEvaluationKey.arrayPitch]: arrayPitchCore,
  [ChecklistEvaluationKey.serialValidation]: serialValidationCore,
  [ChecklistEvaluationKey.solarEdgeOptimizerValidation]: solarEdgeOptimizerCore,
  [ChecklistEvaluationKey.systemLoss]: systemLossCore,
};

export const getEvaluationCore = (key: ChecklistEvaluationKey): EvaluationCoreDescriptor | undefined =>
  checklistEvaluationCoreRegistry[key];
